import { err, ok, Result } from "neverthrow"
import { AppThunk } from "../appStore"
import { FusionError, serializeFusionError, SettingId } from '@fusion-advantage/backcompat'
import { selectStoredSettings } from "../../dal2/storedSetting"
import { restoreAppSliceSettings, restoreRenderSliceSettings, settingPersistRowsToAppSliceSettings, settingPersistRowsToRenderSliceSettings } from '../../lib/setting'
import { pushLogEntry } from "../logSlice"

export const bootRestoreSettings = (): AppThunk<Promise<Result<void, FusionError>>> => async (dispatch, getState) => {
	// only run this once while app is booting!
	if(getState().app.booted) {
		return err(serializeFusionError('bootRestoreSettings', 'already booted'))
	}
	const rSettings = await selectStoredSettings()
	if(rSettings.isErr()) {
		return err(serializeFusionError('bootRestoreSettings', rSettings.error))
	}
	const rows = rSettings.value
	dispatch(restoreAppSliceSettings(settingPersistRowsToAppSliceSettings(rows)))
	dispatch(restoreRenderSliceSettings(settingPersistRowsToRenderSliceSettings(rows)))
	const token = getState().app[SettingId.BearerToken]
	dispatch(pushLogEntry(
		`[bootRestoreSettings] stored auth token ${token ?? 'NOT'} found`
	))
	return ok()
}
